export default "__VITE_ASSET__eeb13585__"